module.exports = __webpack_public_path__ + "img/value2.e77aed11.svg";